import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class OrderCU extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            objs: [],
            objsload: false,

            origin: "-1",
            des: "-1",
            orderdate: '',
            client: '',
            cargo_id: "-1",
            volume:'',
            sale_type:'TPT_Only',
            order_no:'',
            type:'Local',

            distance: '',
            fuelempty: '',
            fuelload: '',
            perdiemempty: '',
            allowancloaded: '',
            handlinefeeempty: '',
            handlinefeeloaded: '',
            isroutefound: false,
            isupdate: null,
            heading1: "",
            heading2: "",
            order_id: -1,
            urlorder: '',

            transport_rate_q:0,
            cement_rate_q:0,
            cement_cost:0,

            //modal
            assignshow: false,
            assigndatas: null,
            assigndatasfilter:[],

            //modal 2
            clientshow: false,
            cusisupdate: false,
            headertext: '',
            id: -1,
            companyname: '',
            contactname: '',
            tin: '',
            vat: '',
            addressline1: '',
            addressline2: '',
            city: '',
            country: '',
            phone: '',
            phone2: '',
            email: '',
            email2: '',
            accountnumber: '',
            bankname: '',
            branch: '',
            ahname: '',
            txtfilter:'',
        }
    }

    async componentDidMount() {
        let baseurl = myconfig.getobjorder;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let type = new URLSearchParams(this.props.location.search).get("type");
        this.setState({
            urlorder: myconfig.order + "?sid=" + sid + "&user=" + user,
        })
        await axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    objsload: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
        if (type == null) {
            var win = window.open(this.state.urlorder, "_self");
        }
        else if (type == "u") {
            let order_id = new URLSearchParams(this.props.location.search).get("order_id");
            baseurl = myconfig.getorder;
            await axios.post(baseurl, {
                "sid": sid,
                "user": user,
                "order_id": order_id,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.message,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    if (res.data.isfound) {
                        this.setState({
                            origin: res.data.order.org,
                            des: res.data.order.des,
                            orderdate: res.data.order.orderdate,
                            cargo_id: res.data.order.cargo_id,
                            volume: res.data.order.volume,
                            distance: res.data.order.distance,
                            fuelempty: res.data.order.fuelempty,
                            fuelload: res.data.order.fuelload,
                            perdiemempty: res.data.order.perdiemempty,
                            allowancloaded: res.data.order.allowancloaded,
                            handlinefeeempty: res.data.order.handlinefeeempty,
                            handlinefeeloaded: res.data.order.handlinefeeloaded,
                            transport_rate_q: res.data.order.transport_rate_q,
                            cement_rate_q: res.data.order.cement_rate_q,
                            cement_cost: res.data.order.cement_cost,
                            sale_type: res.data.order.sale_type,
                            order_no: res.data.order.order_no,
                            type: res.data.order.type,
                            id: res.data.order.client.id,
                            companyname: res.data.order.client.companyname,
                            contactname: res.data.order.client.contactname,
                            tin: res.data.order.client.tin,
                            vat: res.data.order.client.vat,
                            addressline1: res.data.order.client.addressline1,
                            addressline2: res.data.order.client.addressline2,
                            city: res.data.order.client.city,
                            country: res.data.order.client.country,
                            phone: res.data.order.client.phone,
                            email: res.data.order.client.email,
                            email2: res.data.order.client.email2,
                            accountnumber: res.data.order.client.accountnumber,
                            bankname: res.data.order.client.bankname,
                            branch: res.data.order.client.branch,
                            ahname: res.data.order.client.ahname,


                            order_id:order_id,
                            isroutefound: true,
                            isupdate:true,
                            heading1:"Update order allocation",
                            heading2:"Here you can update order allocation.",
                        })
                    } else
                        var win = window.open(this.state.urlorder, "_self");
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else {
            this.setState({
                isupdate:false,
                heading1:"Create a new order allocation",
                heading2:"Here you can create a new order allocation.",
            })
        }
    }

    routemgt =(event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        },()=>this.routefetch())
    }
    btnnew =(event) => {
        event.preventDefault();
        this.reset()
    }
    reset=()=>{
        this.setState({
            origin: "-1",
            des: "-1",
            orderdate: '',
            client: '',
            cargo_id: "-1",
            distance:'',
            fuelempty:'',
            fuelload:'',
            perdiemempty:'',
            allowancloaded:'',
            handlinefeeempty:'',
            handlinefeeloaded:'',
            isroutefound: false,
            sale_type:'TPT_Only',
            order_no:'',
            type:'Local',
            transport_rate_q:0,
            cement_rate_q:0,
            cement_cost:0,
        })
    }
    btnsave =async (event) => {
        event.preventDefault();
        if (this.state.origin == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select Orgin",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.des == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select Destination",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (!this.state.isroutefound)
            Swal.fire({
                title: 'Error!',
                text: "Route is not found",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.orderdate == '')
            Swal.fire({
                title: 'Error!',
                text: "Order date is requred",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.id == -1)
            Swal.fire({
                title: 'Error!',
                text: "Select client",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.cargo_id == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select cargo",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.order_no == "")
            Swal.fire({
                title: 'Error!',
                text: "Enter order #",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if ((isNaN(this.state.volume) || this.state.volume == "") && this.state.isupdate==false)
            Swal.fire({
                title: 'Error!',
                text: "Volume must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
      /*  else if ((isNaN(this.state.transport_rate_q) || this.state.transport_rate_q == ""))
            Swal.fire({
                title: 'Error!',
                text: "Transport rate must be numericwww",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if ((isNaN(this.state.cement_rate_q) || this.state.cement_rate_q == ""))
            Swal.fire({
                title: 'Error!',
                text: "Cement rate must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if ((isNaN(this.state.cement_cost) || this.state.cement_cost == ""))
            Swal.fire({
                title: 'Error!',
                text: "Cement cost must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })*/
        else {
            let baseurl = myconfig.creatorder;
            if(this.state.isupdate)
                baseurl = myconfig.updateorder;
            let redirecttologin = myconfig.redirecttologin;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            await axios.post(baseurl, {
                "sid": sid,
                "org": this.state.origin,
                "des": this.state.des,
                "orderdate": this.state.orderdate,
                "client": this.state.id,
                "cargo_id": this.state.cargo_id,
                "volume": this.state.volume,
                "order_id": this.state.order_id,
                "sale_type": this.state.sale_type,
                "order_no": this.state.order_no,
                "type": this.state.type,
                "transport_rate_q": this.state.transport_rate_q,
                "cement_rate_q": this.state.cement_rate_q,
                "cement_cost": this.state.cement_cost,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success',
                        text: res.data.msg,
                        icon: 'success',
                        confirmButtonText: 'Okay',

                    }).then(value => {
                        this.successumit()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
    }
    successumit=()=> {
        if (this.state.isupdate) {
            window.location.href = this.state.urlorder
        } else
            this.reset()
    }
    successumit2=()=> {
        this.setState({
            clientshow: false,
        }, () => this.getassign())
    }
    routefetch=async ()=> {
        let distance = 'NA'
        let fuelempty = 'NA'
        let fuelload = 'NA'
        let perdiemempty = 'NA'
        let allowancloaded = 'NA'
        let handlinefeeempty = 'NA'
        let handlinefeeloaded = 'NA'
        let isroutefound=false
        if (this.state.org != "-1" && this.state.des != "-1") {
            let baseurl = myconfig.checkroute;
            let redirecttologin = myconfig.redirecttologin;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            await axios.post(baseurl, {
                "sid": sid,
                "org": this.state.origin,
                "des": this.state.des,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.message,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    if (res.data.isfound) {
                        isroutefound=true
                        distance = res.data.distance
                        fuelempty = res.data.fuelempty
                        fuelload = res.data.fuelload
                        perdiemempty = res.data.perdiemempty
                        allowancloaded = res.data.allowancloaded
                        handlinefeeempty = res.data.handlinefeeempty
                        handlinefeeloaded = res.data.handlinefeeloaded
                    }
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        this.setState({
            distance: distance,
            fuelempty: fuelempty,
            fuelload: fuelload,
            perdiemempty: perdiemempty,
            allowancloaded: allowancloaded,
            handlinefeeempty: handlinefeeempty,
            handlinefeeloaded: handlinefeeloaded,
            isroutefound:isroutefound,
        })
    }
    combocargo=()=> {
        let retdata = null;
        if (this.state.objsload) {
            let optiondata = this.state.objs.cargos.map(value => {
                return (<option value={value.id}>{value.cargo_name}</option>)
            })
            retdata = <select className="form-control" value={this.state.cargo_id} name="cargo_id" onChange={this.inputmgt}>
                <option value="-1">--Select Cargo--</option>
                {optiondata}
            </select>
        }
        return (<>{retdata}</>)
    }

    comboorg=()=> {
        let retdata = null;
        let dis=false;
        if(this.state.isupdate)
            dis=true
        if (this.state.objsload) {
            let optiondata = this.state.objs.retroutes.map(value => {
                return (<option value={value.id}>{value.loc_full_name}</option>)
            })
            retdata = <select disabled={dis} className="form-control" value={this.state.origin} name="origin" onChange={this.routemgt}>
                <option value="-1">--Select Origin--</option>
                {optiondata}
            </select>
        }
        return (<>{retdata}</>)
    }
    combodes=()=> {
        let retdata = null;
        let dis=false;
        if(this.state.isupdate)
            dis=true
        if (this.state.objsload) {
            let optiondata = this.state.objs.retroutes.map(value => {
                return (<option value={value.id}>{value.loc_full_name}</option>)
            })
            retdata = <select disabled={dis} className="form-control" value={this.state.des} name="des" onChange={this.routemgt}>
                <option value="-1">--Select Destination--</option>
                {optiondata}
            </select>
        }
        return (<>{retdata}</>)
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    menuhidden = (event) => {
        event.preventDefault();
        if (this.state.menu == "g-sidenav-show bg-gray-100")
            this.setState({
                menu: "g-sidenav-hidden bg-gray-100"
            })
        else
            this.setState({
                menu: "g-sidenav-show bg-gray-100"
            })
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    inputmgttxt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        },()=>this.filterbyText())
    }

    hideassign = () => {
        this.setState({
            assignshow: false,
        })
    }
    modalassign=()=> {
        let count=0;
        let datas=null;
        if(this.state.assigndatas!=null) {
            datas = this.state.assigndatasfilter.map(value => {
                count=count+1;
                return (<tr>
                        <td>{count}</td>
                        <td>
                            <a href="#" onClick={(event => this.selectCustomer(event, value.id))}>Select </a> |
                            <a href="#" onClick={(event => this.update(event, value.id))}>Edit </a>
                        </td>
                        <td>{value.companyname}</td>
                        <td>{value.contactname}</td>
                        <td>{value.tin}</td>
                        <td>{value.vat}</td>
                        <td>{value.addressline1}</td>
                        <td>{value.addressline2}</td>
                        <td>{value.city}</td>
                        <td>{value.country}</td>
                        <td>{value.phone}</td>
                        <td>{value.phone2}</td>
                        <td>{value.email}</td>
                        <td>{value.email2}</td>
                        <td>{value.accountnumber}</td>
                        <td>{value.bankname}</td>
                        <td>{value.branch}</td>
                        <td>{value.ahname}</td>
                    </tr>
                )
            })
        }
        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.assignshow}
                onHide={this.hideassign}>
                <Modal.Header><h4>Vehicle Assigment</h4>
                    <small>({this.state.msg})</small></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="card-tools">
                                        <div className="input-group input-group-sm" style={{width: '150px'}}>
                                            <input type="text" name="txtfilter" value={this.state.txtfilter} onChange={this.inputmgttxt} className="form-control float-right" placeholder="Search" />
                                            <div className="input-group-append">
                                                <button type="submit" className="btn btn-default">
                                                    <i className="fas fa-search" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-header">
                                </div>
                                <div className="card-header">
                                    <h3 className="card-title"></h3>
                                    <div className="card-tools">
                                        <div className="input-group input-group-sm" style={{width: '150px'}}>
                                            <button className="btn btn-outline-primary btn-block" onClick={(event => this.showclient(event,false,-1,"Create"))}>New Customer</button>
                                        </div>
                                    </div>
                                </div>
                                {/* /.card-header */}
                                <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                    <table className="table table-head-fixed text-nowrap">
                                        <thead>
                                        <tr>

                                            <th>#</th>
                                            <th>Action</th>
                                            <th>Company Name</th>
                                            <th>Contact Name</th>
                                            <th>TIN</th>
                                            <th>VAT</th>
                                            <th>Address-1</th>
                                            <th>Address-2</th>
                                            <th>City</th>
                                            <th>Country</th>
                                            <th>Phone-1</th>
                                            <th>Phone-2</th>
                                            <th>Email-1</th>
                                            <th>Email-2</th>
                                            <th>Account #</th>
                                            <th>Banck Name</th>
                                            <th>Branch</th>
                                            <th>Account Holder Name</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {datas}
                                        </tbody>
                                    </table>
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>

                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    btnassign = (event) => {
        event.preventDefault();
        this.getassign();
    }
    getassign=()=>{
        let baseurl = myconfig.getcustomers;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    assignshow: true,
                    assigndatas: res.data,
                    assigndatasfilter: res.data.datas,
                    headertext: '',
                    id: -1,
                    companyname: '',
                    contactname: '',
                    tin: '',
                    vat: '',
                    addressline1: '',
                    addressline2: '',
                    city: '',
                    country: '',
                    phone: '',
                    phone2: '',
                    email: '',
                    email2: '',
                    accountnumber: '',
                    bankname: '',
                    branch: '',
                    ahname: '',
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    hideclient = () => {
        this.setState({
            clientshow: false,
            headertext: '',
            id: -1,
            companyname: '',
            contactname: '',
            tin: '',
            vat: '',
            addressline1: '',
            addressline2: '',
            city: '',
            country: '',
            phone: '',
            phone2: '',
            email: '',
            email2: '',
            accountnumber: '',
            bankname: '',
            branch: '',
            ahname: '',
        })
    }
    showclient = (event,isupdate,id,headertext) => {
        this.setState({
            clientshow:true,
            assignshow: false,
            cusisupdate:isupdate,
            id:id,
            headertext:headertext,
        })
    }
    modalclient=()=> {
        let count=0;
        /*let datas=this.state.vehicles.map(value => {
            count=count+1;
            let active=value.gpsactive===true?"Yes":"No"
            return (<tr>
                    <td>{count}</td>
                    <td>{value.plateno}</td>
                    <td>{value.capacity}</td>
                    <td>{value.type}</td>
                    <td>{value.tname}</td>
                    <td>{value.status}</td>
                    <td>{value.name}</td>
                    <td>{value.phoneno}</td>
                    <td>{value.tplateno}</td>
                    <td>{value.orderdate}</td>
                    <td>{value.loc}</td>
                    <td>{value.time}</td>
                    <td>{value.leftkm}</td>
                    <td>{active}</td>
                    <td>
                        <button className="form-control btn btn-sm btn-outline-primary" onClick={(event => this.btnassign(event,value.assign_id))}>Select</button>
                    </td>
                </tr>
            )
        })*/
        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.clientshow}
                onHide={this.hideclient}>
                <Modal.Header><h4>Customer Management </h4>
                    <small>({this.state.headertext})</small></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body p-0">
                                    <div className="row">
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Company Name</label>
                                                <input  className="form-control" type="text" name="companyname" onChange={this.inputmgt} value={this.state.companyname}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Contact Person</label>
                                                <input  className="form-control" type="text" name="contactname" onChange={this.inputmgt} value={this.state.contactname}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>TIN</label>
                                                <input  className="form-control" type="text" name="tin" onChange={this.inputmgt} value={this.state.tin}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>VAT</label>
                                                <input  className="form-control" type="text" name="vat" onChange={this.inputmgt} value={this.state.vat}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Address-1</label>
                                                <input  className="form-control" type="text" name="addressline1" onChange={this.inputmgt} value={this.state.addressline1}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Address-2</label>
                                                <input  className="form-control" type="text" name="addressline2" onChange={this.inputmgt} value={this.state.addressline2}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>City</label>
                                                <input  className="form-control" type="text" name="city" onChange={this.inputmgt} value={this.state.city}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Country</label>
                                                <input  className="form-control" type="text" name="country" onChange={this.inputmgt} value={this.state.country}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Phone-1</label>
                                                <input  className="form-control" type="text" name="phone" onChange={this.inputmgt} value={this.state.phone}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Phone-2</label>
                                                <input  className="form-control" type="text" name="phone2" onChange={this.inputmgt} value={this.state.phone2}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Email-1</label>
                                                <input  className="form-control" type="email" name="email" onChange={this.inputmgt} value={this.state.email}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Email-2</label>
                                                <input  className="form-control" type="email" name="email2" onChange={this.inputmgt} value={this.state.email2}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Account #</label>
                                                <input  className="form-control" type="text" name="accountnumber" onChange={this.inputmgt} value={this.state.accountnumber}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Bank Name</label>
                                                <input  className="form-control" type="text" name="bankname" onChange={this.inputmgt} value={this.state.bankname}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Branch</label>
                                                <input  className="form-control" type="text" name="branch" onChange={this.inputmgt} value={this.state.branch}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                                <label>Account Holder Name</label>
                                                <input  className="form-control" type="text" name="ahname" onChange={this.inputmgt} value={this.state.ahname}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group">
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-3">
                                            <div className="form-group d-flex justify-content-around">
                                                <button className="btn btn-outline-primary" onClick={this.btnsumbitcustomer}> Save </button>
                                                <button className="btn btn-outline-danger"> Cancel </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>

                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    btnsumbitcustomer=(event)=> {
        event.preventDefault()
        let baseurl = myconfig.createcustomer
        let id = -1;
        if (this.state.cusisupdate) {
            baseurl = myconfig.updatecustomer
            id = this.state.id
        }
        if (this.state.companyname == "")
            Swal.fire({
                title: 'Error!',
                text: "Company name required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.contactname == "")
            Swal.fire({
                title: 'Error!',
                text: "Contact name required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.tin == "")
            Swal.fire({
                title: 'Error!',
                text: "TIN required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.vat == "")
            Swal.fire({
                title: 'Error!',
                text: "VAT required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.addressline1 == "")
            Swal.fire({
                title: 'Error!',
                text: "Address-1 required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.city == "")
            Swal.fire({
                title: 'Error!',
                text: "City required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.country == "")
            Swal.fire({
                title: 'Error!',
                text: "Country required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.phone == "")
            Swal.fire({
                title: 'Error!',
                text: "Phone required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.email == "")
            Swal.fire({
                title: 'Error!',
                text: "Email required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.accountnumber == "")
            Swal.fire({
                title: 'Error!',
                text: "Account # required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.bankname == "")
            Swal.fire({
                title: 'Error!',
                text: "Bank name required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.branch == "")
            Swal.fire({
                title: 'Error!',
                text: "Branch required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.ahname == "")
            Swal.fire({
                title: 'Error!',
                text: "Account holder name required",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else {
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            let type = new URLSearchParams(this.props.location.search).get("type");
            this.setState({
                urlorder: myconfig.order + "?sid=" + sid + "&user=" + user,
            })
            axios.post(baseurl, {
                "sid": sid,
                "user": user,
                "id": id,
                "companyname": this.state.companyname,
                "contactname": this.state.contactname,
                "tin": this.state.tin,
                "vat": this.state.vat,
                "addressline1": this.state.addressline1,
                "addressline2": this.state.addressline2,
                "city": this.state.city,
                "country": this.state.country,
                "email": this.state.email,
                "email2": this.state.email2,
                "phone": this.state.phone,
                "phone2": this.state.phone2,
                "accountnumber": this.state.accountnumber,
                "bankname": this.state.bankname,
                "branch": this.state.branch,
                "ahname": this.state.ahname,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success!',
                        text: res.data.msg,
                        icon: 'success',
                        confirmButtonText: 'Okay'
                    }).then(value => {
                        this.successumit2()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
    }
    update=(event,id)=> {
        event.preventDefault()
        let temp = this.state.assigndatas.datas.filter(value => {
            if (value.id == id)
                return value;
        })
        if (temp.length > 0) {
            this.setState({
                clientshow: true,
                cusisupdate: true,
                headertext: 'Update',
                id: id,
                companyname: temp[0].companyname,
                contactname: temp[0].contactname,
                tin: temp[0].tin,
                vat: temp[0].vat,
                addressline1: temp[0].addressline1,
                addressline2: temp[0].addressline2,
                city: temp[0].city,
                country: temp[0].country,
                phone: temp[0].phone,
                phone2: temp[0].phone2,
                email: temp[0].email,
                email2: temp[0].email2,
                accountnumber: temp[0].accountnumber,
                bankname: temp[0].bankname,
                branch: temp[0].branch,
                ahname: temp[0].ahname,
            })
        }
    }
    selectCustomer=(event,id)=> {
        event.preventDefault()
        this.setState({
            assignshow: false,
            id:id,
        },()=>this.refreshcustomer())
    }
    refreshcustomer=()=> {
        let temp = this.state.assigndatas.datas.filter(value => {
            if (value.id == this.state.id)
                return value;
        })
        if (temp.length > 0) {
            this.setState({
                companyname: temp[0].companyname,
                contactname: temp[0].contactname,
                tin: temp[0].tin,
                vat: temp[0].vat,
                addressline1: temp[0].addressline1,
                addressline2: temp[0].addressline2,
                city: temp[0].city,
                country: temp[0].country,
                phone: temp[0].phone,
                phone2: temp[0].phone2,
                email: temp[0].email,
                email2: temp[0].email2,
                accountnumber: temp[0].accountnumber,
                bankname: temp[0].bankname,
                branch: temp[0].branch,
                ahname: temp[0].ahname,
            })
        } else {
            this.setState({
                id: -1,
                companyname: '',
                contactname: '',
                tin: '',
                vat: '',
                addressline1: '',
                addressline2: '',
                city: '',
                country: '',
                phone: '',
                phone2: '',
                email: '',
                email2: '',
                accountnumber: '',
                bankname: '',
                branch: '',
                ahname: '',
            })
        }
    }
    filterbyText=()=> {
        let temp = this.state.assigndatas.datas;
        if (this.state.txtfilter == "")
        {
            this.setState({
                assigndatasfilter: temp,
            })
        }
        else {
            temp = temp.filter(value => {
                if (
                    value.companyname.toUpperCase().includes(this.state.txtfilter.toUpperCase())||
                    value.contactname.toUpperCase().includes(this.state.txtfilter.toUpperCase())
                )
                    return value;
            })
            this.setState({
                assigndatasfilter: temp,
            })
        }
    }

    render() {
        let dis=false;
        if(this.state.isupdate)
            dis=true;
        return (
            <>
                <Nav type="oordermgt"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Order Create</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Order List</a></li>
                                        <li className="breadcrumb-item active">Order Create</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="card card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">Route Information</h3>
                                        </div>
                                        <form>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Origin</label>
                                                    {this.comboorg()}
                                                </div>
                                                <div className="form-group">
                                                    <label>Destination</label>
                                                    {this.combodes()}
                                                </div>
                                                <div className="form-group">
                                                    <label>DISTANCE</label>
                                                    <input disabled className="form-control" type="text" name="distance" onChange={this.inputmgt} value={this.state.distance}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>FUEL-EMPTY</label>
                                                    <input disabled className="form-control" type="text" name="fuelempty" onChange={this.inputmgt} value={this.state.fuelempty}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>FUEL-LOADED</label>
                                                    <input disabled className="form-control" type="text" name="fuelload" onChange={this.inputmgt} value={this.state.fuelload}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>PER DIEM</label>
                                                    <input disabled className="form-control" type="text" name="perdiemempty" onChange={this.inputmgt} value={this.state.perdiemempty}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>ALLOWANCE</label>
                                                    <input disabled className="form-control" type="text" name="allowancloaded" onChange={this.inputmgt} value={this.state.allowancloaded}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>HANDLING FEES Empty</label>
                                                    <input disabled className="form-control" type="text" name="handlinefeeempty" onChange={this.inputmgt} value={this.state.handlinefeeempty}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>HANDLING FEES Loaded</label>
                                                    <input disabled className="form-control" type="text" name="handlinefeeloaded" onChange={this.inputmgt} value={this.state.handlinefeeloaded}/>
                                                </div>
                                            </div>
                                            <div className="card-footer">
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="card card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">Order Allocation</h3>
                                        </div>
                                        <form>
                                            <div className="row">
                                                <div className="col-12 col-sm-6">
                                                </div>
                                                <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                </div>
                                                <div className="col-12 col-sm-6 mt-3 mt-sm-0">

                                                </div>
                                                <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Order</label>
                                                    <input name="orderdate" value={this.state.orderdate} className="form-control" type="date" onChange={this.inputmgt}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>Order #</label>
                                                    <input name="order_no" value={this.state.order_no} className="form-control" type="text" onChange={this.inputmgt}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>Cargo</label>
                                                    {this.combocargo()}
                                                </div>
                                                <div className="form-group">
                                                    <label>Volume</label>
                                                    <input disabled={dis} name="volume" value={this.state.volume} className="form-control" type="text" onChange={this.inputmgt}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>Sale Type</label>
                                                    <select name="sale_type" value={this.state.sale_type} className="form-control" onChange={this.inputmgt}>
                                                        <option value="TPT_Only">TPT_Only</option>
                                                        <option value="TPT+CMT">TPT+CMT</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Type</label>
                                                    <select name="type" value={this.state.type} className="form-control" onChange={this.inputmgt}>
                                                        <option value="Local">Local</option>
                                                        <option value="Cross-Boarder">Cross-Boarder</option>
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Transport Rate</label>
                                                    <input name="transport_rate_q" value={this.state.transport_rate_q} className="form-control" type="text" onChange={this.inputmgt}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>Cement Rate</label>
                                                    <input name="cement_rate_q" value={this.state.cement_rate_q} className="form-control" type="text" onChange={this.inputmgt}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>Cement Cost</label>
                                                    <input name="cement_cost" value={this.state.cement_cost} className="form-control" type="text" onChange={this.inputmgt}/>
                                                </div>
                                                <div className="form-group">
                                                    <label>Client</label>
                                                    <button className="btn btn-outline-primary btn-block" onClick={this.btnassign}>Select Customer</button>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Company Name</label>
                                                            <input disabled  className="form-control" type="text" name="companyname" onChange={this.inputmgt} value={this.state.companyname}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Contact Person</label>
                                                            <input  disabled className="form-control" type="text" name="contactname" onChange={this.inputmgt} value={this.state.contactname}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>TIN</label>
                                                            <input  disabled className="form-control" type="text" name="tin" onChange={this.inputmgt} value={this.state.tin}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>VAT</label>
                                                            <input  disabled className="form-control" type="text" name="vat" onChange={this.inputmgt} value={this.state.vat}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Address-1</label>
                                                            <input  disabled className="form-control" type="text" name="addressline1" onChange={this.inputmgt} value={this.state.addressline1}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Address-2</label>
                                                            <input  disabled className="form-control" type="text" name="addressline2" onChange={this.inputmgt} value={this.state.addressline2}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>City</label>
                                                            <input  disabled className="form-control" type="text" name="city" onChange={this.inputmgt} value={this.state.city}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Country</label>
                                                            <input  disabled className="form-control" type="text" name="country" onChange={this.inputmgt} value={this.state.country}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Phone-1</label>
                                                            <input  disabled className="form-control" type="text" name="phone" onChange={this.inputmgt} value={this.state.phone}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Phone-2</label>
                                                            <input  disabled className="form-control" type="text" name="phone2" onChange={this.inputmgt} value={this.state.phone2}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Email-1</label>
                                                            <input  disabled className="form-control" type="email" name="email" onChange={this.inputmgt} value={this.state.email}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Email-2</label>
                                                            <input  disabled className="form-control" type="email" name="email2" onChange={this.inputmgt} value={this.state.email2}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Account #</label>
                                                            <input  disabled className="form-control" type="text" name="accountnumber" onChange={this.inputmgt} value={this.state.accountnumber}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Bank Name</label>
                                                            <input  disabled className="form-control" type="text" name="bankname" onChange={this.inputmgt} value={this.state.bankname}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Branch</label>
                                                            <input  disabled className="form-control" type="text" name="branch" onChange={this.inputmgt} value={this.state.branch}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 px-3">
                                                        <div className="form-group">
                                                            <label>Account Holder Name</label>
                                                            <input  disabled className="form-control" type="text" name="ahname" onChange={this.inputmgt} value={this.state.ahname}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-footer">
                                                <button type="submit" className="btn btn-primary" onClick={this.btnsave}>Submit</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalassign()}
                {this.modalclient()}
            </>
        )
    }
}

export default OrderCU;
